import { Typography } from "@material-ui/core";
import { useStyles } from "../styles";

interface Props {
  label: string;
  data: string | number | React.ReactNode;
  type: "column" | "row";
}

export default function DataItem(props: Props) {
  const { type, label, data } = props;
  const classes = useStyles();
  const containerClass =
    type === "column"
      ? classes.dataItemColumnContainer
      : classes.dataItemRowContainer;

  return (
    <div className={containerClass}>
      <Typography
        className={classes.dataItemLabel}
        variant="caption"
        color="textSecondary"
      >
        {label}
      </Typography>
      <Typography className={classes.dataItem}>{data}</Typography>
    </div>
  );
}
